import React, { useState } from "react";
import { Box, Button, IconButton, Paper } from "@mui/material";
import ClaimTabs from "../../claims/common/ClaimTabs";
import activeResume from "../../../../assets/images/activeResume.svg";
import activeDeceased from "../../../../assets/images/activeDeceased.svg";
import inactiveDeceased from "../../../../assets/images/inactiveDeceased.svg";
import inactiveResume from "../../../../assets/images/inactiveResume.svg";
import PersonalDetails from "./personal-details/PersonalDetails";
import DriverDocuments from "./driver-documents/DriverDocuments";
import { BorderColorOutlined as BorderColorOutlinedIcon } from "../../../../components/icons";
import {
  OperationsPageShell,
  OperationsSectionHeader,
  operationsActionBarSx,
  operationsDetailPaperSx,
} from "../../ifas/components/OperationsUI";

export default function DriverDetails(props: any) {
  const { onHistoryClick, readOnly = false } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const updateRef = React.useRef<null | (() => Promise<void>)>(null);

  const deriverPortalTabs = [
    {
      id: 0,
      icon: { active: activeResume, inactive: inactiveResume },
      alt: " Personal Details",
    },
    {
      id: 1,
      icon: { active: activeDeceased, inactive: inactiveDeceased },
      alt: " Document Details",
    },
  ];

  const renderTitle = () => {
    return tabData[activeTab]?.alt || "";
  };

  const tabData = deriverPortalTabs;

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <PersonalDetails
            isEditing={readOnly ? false : isEditing}
            setIsEditing={setIsEditing}
            registerUpdateHandler={(fn) => {
              updateRef.current = fn;
            }}
          />
        );
      case 1:
        return <DriverDocuments />;
      default:
        return null;
    }
  };

  return (
    <OperationsPageShell
      eyebrow="Driver Details"
      title={renderTitle().trim()}
      description="View driver profile information, licence status, and uploaded driver documents from the selected fleet record."
      actions={
        <Box sx={operationsActionBarSx}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onHistoryClick}
          >
            History
          </Button>
          {activeTab === 0 && !readOnly && !isEditing && (
            <IconButton onClick={() => setIsEditing(true)}>
              <BorderColorOutlinedIcon
                sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
              />
            </IconButton>
          )}
          {activeTab === 0 && !readOnly && isEditing && (
            <>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setIsEditing(false)}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => updateRef.current?.()}
              >
                Update
              </Button>
            </>
          )}
        </Box>
      }
    >
      <Paper
        sx={operationsDetailPaperSx}
        elevation={0}
      >
        <ClaimTabs
          tabs={tabData}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        <Box mt={3}>
          {renderTabContent()}
        </Box>
      </Paper>
    </OperationsPageShell>
  );
}
